import React from 'react'
import ConsoleEmbed from 'components/ConsoleEmbed'
import { REPORT_KEYS } from 'constants/reporting'
import { isAgentLogin, isCarrierLogin } from 'tools/auth'
import { useEnsureInvitingCompanyId } from 'hooks/useEnsureInvitingCompanyId'

/**
 * UBI Summary — single-company underwriting snapshot embedded from tc-console
 * (reportType 'ubi-summary'). Shown as a tab in the carrier-detail (insurer) view
 * and, when the feature flag is on, in the carrier's own Fleet Reporting view.
 *
 * Rendered via <ConsoleEmbed>: real token auth + the carrier-api `report_config`
 * row for 'ubi-summary' (base_url + report_type). The tab is gated by the
 * feature flag reporting.ubi-summary.use-console — an insurer-level setting. carrier-api
 * resolves it against the company that owns the portal the request comes from (derived from the
 * Origin sub-domain / short code), falling back to the caller's own company when the origin maps
 * to none.
 *
 * Scope params follow the same positional contract as the other console-embedded
 * reports (mileage, safety events, …):
 *   - Insurer/agent: the token company is the insurer; carrierId names the carrier
 *     being viewed. (Agents also pass invitingCompanyId.)
 *   - Carrier: the token company IS the carrier, so we send invitingCompanyId (the
 *     insurer that owns the fleet's CEAs) instead of carrierId — the console reads
 *     the carrier off the token and scopes the CEAs under the insurer.
 */
const UbiSummaryDashboard: React.FC = () => {
  const ensuredInvitingCompanyId = useEnsureInvitingCompanyId()
  const isAgentOrCarrier = isCarrierLogin() || isAgentLogin()
  const invitingCompanyId = isAgentOrCarrier
    ? ensuredInvitingCompanyId
    : undefined
  const carrierId = !isCarrierLogin()
    ? localStorage.getItem('carrierId') || undefined
    : undefined
  const eldProvider = localStorage.getItem('eldProviderRisk') || undefined
  return (
    <ConsoleEmbed
      reportKey={REPORT_KEYS.UBI_SUMMARY}
      invitingCompanyId={invitingCompanyId}
      carrierId={carrierId}
      eldProvider={eldProvider}
    />
  )
}

export default UbiSummaryDashboard
